import { render, staticRenderFns } from "./BundleItemsFormItems.vue?vue&type=template&id=3249b864&"
import script from "./BundleItemsFormItems.vue?vue&type=script&lang=js&"
export * from "./BundleItemsFormItems.vue?vue&type=script&lang=js&"
import style0 from "./BundleItemsFormItems.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3249b864')) {
      api.createRecord('3249b864', component.options)
    } else {
      api.reload('3249b864', component.options)
    }
    module.hot.accept("./BundleItemsFormItems.vue?vue&type=template&id=3249b864&", function () {
      api.rerender('3249b864', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BundleItemsFormItems.vue"
export default component.exports